import { storeToRefs } from 'pinia'
import { useSidenavStateStore } from '@src/pinia/sidenavState'

export function useSidenavState() {
  const store = useSidenavStateStore()
  const { isSidenavOpen } = storeToRefs(store)
  const { toggleSidenav } = store
  return {
    isSidenavOpen,
    toggleSidenav
  }
}
